<div class="d-flex flex-column justify-content-center align-items-center p-3 footer-container">
    <div>
        <ul class="d-flex list-inline ">
            <li *ngFor="let data of footerData"
                class="d-flex border-class">
                <!-- Remove condition once Terms and Conditions page has been developed -->
                <ng-container *ngIf="data.link !== 'publicTermsConditions' && data.label !== 'Your California Privacy Choices'">
                    <a class="ms-3 me-3 text-white fw-normal"
                        href="{{data.link}}"
                        target="_blank"
                        rel="noopener"
                        role="button">{{data.label}}</a>
                </ng-container>
                <ng-container *ngIf="data.link === 'publicTermsConditions'">
                    <a (click)="termsAndcondition()"
                        class="ms-3 me-3 text-white fw-normal"
                        role="button">{{data.label}}</a>
                </ng-container>
                <ng-container *ngIf="data.label === 'Your California Privacy Choices'">
                    <a (click)="privacyChoices()"
                        class="ms-3 me-3 text-white fw-normal"
                        role="button">{{data.label}}</a>
                </ng-container>
                <img [src]="data?.src"
                    alt=""
                    width="40"
                    *ngIf="data?.label === 'Your California Privacy Choices'">
            </li>
        </ul>
    </div>
    <div class="text-white fw-normal" *ngIf="footerData.length>0">
        © {{currentDate}} The Hartford
    </div>

</div>